import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { PhoneSlash, VideoCamera } from "@phosphor-icons/react";

export default function VideoRoom() {
  const { apptId } = useParams();
  const { user } = useAuth();
  const nav = useNavigate();
  const [apt, setApt] = useState(null);

  useEffect(() => {
    api.get("/appointments/mine").then((r) => {
      const found = r.data.find((a) => a.id === apptId);
      setApt(found);
    });
  }, [apptId]);

  const roomName = `aarogya-${apptId}`;
  const displayName = encodeURIComponent(user?.name || "Guest");
  const jitsiUrl = `https://meet.jit.si/${roomName}#userInfo.displayName="${displayName}"&config.prejoinPageEnabled=false`;

  return (
    <div className="min-h-screen bg-charcoal flex flex-col">
      <div className="bg-ayurveda text-bone p-4 flex items-center justify-between">
        <div>
          <div className="overline text-terracotta text-[10px]">Video consultation</div>
          <div className="font-clinical text-lg">
            {apt ? `${apt.doctor_name} · ${apt.specialty}` : "Loading…"}
          </div>
        </div>
        <Button variant="destructive" onClick={() => nav("/app/appointments")} data-testid="video-end-btn">
          <PhoneSlash size={16} className="mr-2" /> End call
        </Button>
      </div>
      <div className="flex-1 bg-black">
        <iframe
          title="Jitsi video room"
          src={jitsiUrl}
          allow="camera; microphone; fullscreen; display-capture; autoplay"
          className="w-full h-full border-0"
          data-testid="jitsi-frame"
        />
      </div>
      <div className="bg-charcoal text-bone/60 text-xs px-4 py-2 text-center">
        <VideoCamera size={12} weight="duotone" className="inline mr-1" />
        Powered by Jitsi Meet · Peer-to-peer encrypted
      </div>
    </div>
  );
}
